/**
 * Created by Mark on 23/11/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants/recent-activity.js';
import Actions from '../actions/default.js';
import InternationalizationService from './internationalization-service.js'
import InternationalizationStore from '../store/internationalization-store.js';
class RecentActivityService {

    getDashboard(){
        InternationalizationService.getUserTranslations(InternationalizationStore.determineLocaleFromBrowser());
        return ApplicationServices.call(Constants.GET_DASHBOARD_ACTIVITY , {} ).then(function(response){
            Actions.update(Constants.UPDATE_DASHBOARD_ACTIVITY , response['activity'])
        });
    }

}

export default new RecentActivityService();


// WEBPACK FOOTER //
// ./src/services/recent-activity-services.js